import _ from 'lodash'
import { defineStore } from 'pinia'

import router from '../router'
import { useGlobalStore } from './global'

export const useAuthStore = defineStore('auth', {
	state: () => {
		return {
			user: null,
		}
	},
	getters: {
		isAuthed: (state) => state.user && !_.isEmpty(state.user),
		isAuthenticating: (state) => (!state.user ? true : false),
	},
	actions: {
		setup() {
			this.auth()
		},
		auth() {
			return axios
				.get('/api/auth')
				.then((user) => {
					this.user = user.data
				})
				.catch((error) => {
					console.error(error)
				})
		},
		checkAuth() {
			return new Promise((resolve, reject) => {
				axios
					.get('/api/auth')
					.then((user) => {
						this.user = user.data
						resolve()
					})
					.catch((error) => {
						console.error(error)
						reject(error.response.data.errors)
					})
			})
		},
		login(data) {
			const global = useGlobalStore()
			return new Promise((resolve, reject) => {
				axios
					.post('/login', data)
					.then((response) => {
						if (response.data.two_factor) {
							global.openModal(['2fa'])
						} else {
							this.auth().then(() => {
								global.closeModal()
								// router.replace({ name: 'profile', params: { username: data.username } })
							})
						}
					})
					.catch((error) => {
						console.log(error)
						if (error.response.status === 422) {
							reject(error.response.data.errors)
						}
					})
			})
		},
		register(data) {
			const global = useGlobalStore()
			return new Promise((resolve, reject) => {
				axios
					.post('/register', data)
					.then(() => {
						this.auth().then(() => {
							global.closeModal()
							router.replace({ name: 'profile', params: { username: data.username } })
						})
					})
					.catch((error) => {
						if (error.response.status === 422) {
							reject(error.response.data.errors)
						}
					})
			})
		},
		updateProfile(data) {
			return new Promise((resolve, reject) => {
				axios
					.post('/api/profile', data)
					.then(() => {
						this.auth().then(() => {
							resolve()
						})
					})
					.catch((error) => {
						if (error.response.status === 422) {
							reject(error.response.data.errors)
						}
					})
			})
		},
		updateAccount(data) {
			console.log(data)
			return new Promise((resolve, reject) => {
				axios
					.post('/api/account', data)
					.then(() => {
						this.auth().then(() => {
							resolve()
						})
					})
					.catch((error) => {
						if (error.response.status === 422) {
							reject(error.response.data.errors)
						}
					})
			})
		},
		// 2FA
		enable2FA() {
			return new Promise((resolve, reject) => {
				axios.post('/user/two-factor-authentication').then(() => {
					this.auth().then(() => {
						resolve()
					})
				})
			})
		},
		disable2FA() {
			return new Promise((resolve, reject) => {
				axios.delete('/user/two-factor-authentication').then(() => {
					this.auth().then(() => {
						resolve()
					})
				})
			})
		},
		setup2FA() {
			return new Promise((resolve, reject) => {
				Promise.all([axios.get('/user/two-factor-qr-code'), axios.get('/user/two-factor-secret-key'), axios.get('/user/two-factor-recovery-codes')])
					.then(([qr, secretKey, recoveryCodes]) => {
						const details = {
							qr: qr?.data?.svg ?? null,
							secretKey: secretKey?.data?.secretKey ?? null,
							recoveryCodes: recoveryCodes.data ?? null,
						}
						resolve(details)
					})
					.catch(reject)
			})
		},
		confirm2FA(authCode) {
			return new Promise((resolve, reject) => {
				axios
					.post('/user/confirmed-two-factor-authentication', { code: authCode })
					.then(() => {
						this.auth().then(() => {
							resolve()
						})
					})
					.catch((error) => {
						console.error(error)
						if (error.response.status === 422) {
							reject(error.response.data.errors)
						}
					})
			})
		},
		submit2FA(authCode) {
			const global = useGlobalStore()
			let code = authCode.length === 6 ? { code: authCode } : { recovery_code: authCode }
			return new Promise((resolve, reject) => {
				axios
					.post('/two-factor-challenge', code)
					.then(() => {
						this.auth().then(() => {
							global.closeModal()
							// router.replace({ name: 'profile', params: { username: user.username } })
						})
					})
					.catch((error) => {
						if (error.response.status === 422) {
							reject(error.response.data.errors)
						}
					})
			})
		},
	},
})
